import React from "react";
import { useField } from "formik";
import "./NpsScale.css";

const NpsScale = ({
  field_label,
  displayLabel: rawDisplayLabel,
  field_key,
  min = 0,
  max = 10,
  isRequired,
}) => {
  const [field, , helpers] = useField(field_key);
  const displayLabel = (rawDisplayLabel || field_label)?.replaceAll("_", " ");

  return (
    <div className="nps-wrapper">
      <label className="nps-label">
        {displayLabel}

        {isRequired && <span className="nps-required">*</span>}
      </label>

      <div className="nps-scale">
        {Array.from({ length: max - min + 1 }, (_, i) => i + min).map((num) => (
          <button
            key={num}
            type="button"
            className={`nps-box ${field.value === num ? "nps-box--selected" : ""}`}
            onClick={() => helpers.setValue(num)}>
            {num}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NpsScale;
